const { preOrderRequestFormCache } = window.BAO.Caches

class PreOrderRequestFormRenderer extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['form']
  }

  setupListeners () {
    super.setupListeners()

    this.handleToggleClick = this.handleToggleClick.bind(this)
    this.handleToggleHover = this.handleToggleHover.bind(this)

    if (this.externalEls.toggle) {
      this.externalEls.toggle.elements.forEach(toggle => {
        this.listeners.add(toggle, 'click', this.handleToggleClick)
      })

      this.externalEls.toggle.elements.forEach(toggle => {
        this.listeners.add(toggle, 'mouseover', this.handleToggleHover)
      })
    }
  }

  /** @param {MouseEvent} event */
  handleToggleHover (event) {
    /** @type {HTMLElement} */
    const toggle = event.currentTarget
    const handle = toggle.dataset.productHandle

    preOrderRequestFormCache.get(handle)
  }

  /** @param {MouseEvent} event */
  handleToggleClick (event) {
    /** @type {HTMLElement} */
    const toggle = event.currentTarget
    const handle = toggle.dataset.productHandle

    this.render(handle)
  }

  /** @param {string} handle */
  async render (handle) {
    /**
     * If the current product is already rendered we don't
     * want to re-render, otherwise we lose the form state
     */
    const shouldRerender = handle !== this.currentProduct
    if (!shouldRerender) {
      return
    }

    const html = await preOrderRequestFormCache.get(handle)
    const dom = new DOMParser().parseFromString(html, 'text/html')

    this.innerHTML = dom.querySelector(this.els.form.selector).outerHTML
  }

  /** @returns {string} */
  get currentProduct () {
    return this.els.form.element.dataset.productHandle
  }
}

if (!window.customElements.get('pre-order-request-form-renderer')) {
  window.customElements.define(
    'pre-order-request-form-renderer',
    PreOrderRequestFormRenderer,
    { extends: 'aside' },
  )
}
